<template>
  <div class="cx_editor" :class="{loading : isLoading}">
    <div class="cx_editor_content" v-if="item != null">
      <!-- タブなしモード -->
      <div v-if="tabs == undefined" class="cx_vertical_fill">
        <div class="cx_editor_content_header"></div>
        <b-container class="cx_vertical_scroll">
          <slot name="control" :item="item" :editor="_self"></slot>
        </b-container>
      </div>
      <!-- 基本情報タブ -->
      <div v-if="tabs != undefined && columnStyle" class="cx_editor_content_header">  
        <!-- <div class="cx_edtior_caption" v-if="tabs && tabs.length>0"><span >{{tabs[0]}}</span></div>           -->
        <slot :name="'tab0'" :item="item" :editor="_self"></slot>
      </div>
      <!-- タブ表示モード -->
      <Tab class="cx_vertical_fill" v-if="tabs != undefined" :scrollWidth="columnStyle ? 80 : 200" :tabs="adjust(tabs)" :visibles="adjust(tabVisibles)" :invalids="tabInvalids" ref="tab" :tooltips="adjust(tabTooltips)" :svg="owner && (columnStyle== false) ? owner.svg : null">
        <div class="cx_editor_body" v-for="(title, index) in adjust(tabs)" :key="owner ? owner.bindIndex * 100+ index:index" :slot="'tab' + index" :ref="'tab' + index">
          <slot :name="'tab' + (columnStyle ? index + 1 : index).toString()" :item="item" :editor="_self"></slot>
        </div>
      </Tab>
    </div>    
    <!-- フッタ(アクションボタン～spModeでは非表示) -->
    <div class="cx_editor_footer_border"  v-if="item != null && $api.spMode == false && isMinimized == false && tooltip && tooltipVisible && (owner && owner.dialogMode)">

      <div class="cx_editor_footer_border_innter"  >
        <toggle-button v-if="tooltip && tooltipVisible" v-model="actionTooltipVisible" :labels="{checked: '操作ガイドオン', unchecked: '操作ガイドオフ'}" :width="110" :font-size="11" color="#7a2e2e"/>           
        <span class="cx_tooltip_message" v-if="tooltip && tooltipVisible && actionTooltipVisible" :class="{tooltip_alert : tooltipIsAlert}">{{tooltip}}</span> 

      </div>
    </div>
    <div class="cx_editor_footer_container" >
    <div class="cx_editor_footer_wrapper"  v-if="item != null && !(owner && owner.popup)">
      <!--
      <div class="cx_editor_tooltip" v-if="tooltip && tooltipVisible">
        <span>次の操作は<i class="material-icons small valign"  ref="tooltip_target">help_outline</i></span>   
      </div>    
      -->


      <!-- ツールチップ表示有無でPaddingが異なっていたため共通化 =>ダイアログ or spMode時 or 管理サイトに限定-->
      <div class="cx_editor_footer left  cx_appevent_enabled cx_footer_nopadding" v-if="($scopedSlots.menu || tooltip) && item != null &&isActionState==false && editVisible==false && closeVisible==false && ((owner && owner.dialogMode) || $api.spMode || isAdminSite)">
        <slot name="menu" :item="item" :editor="_self"></slot>   
      </div>    
        <!-- ヘルプコンテンツをコメント -->      
      <!-- <div  class="cx_editor_footer_toggle" v-if="item != null &&isActionState==false && editVisible==false && closeVisible==false">        
        <HelpContent :tag="owner ? owner.title : null" :left="columnStyle"/>
      </div> -->
      <!-- ダイアログ or spMode時に限定 -->
      <div class="cx_editor_footer_workflow cx_appevent_enabled"  v-if="($scopedSlots.menu || tooltip) && item != null &&isActionState==false && editVisible==false && closeVisible==false && ((owner && owner.dialogMode) || $api.spMode)">
        <slot name="menu_right" :item="item" :editor="_self"></slot>              
        <Workflow :item="item" :index="owner.currentId" :isToolbar="true" :preSendAction="owner.$parent.preSendAction" @updated="owner.$parent.onWorkflow" v-if="owner && owner.$parent && owner.$parent.onWorkflow" :perm="owner.perm + '.approve'"/>             
      </div>        
      <!-- ダイアログ表示用に位置を移動 -->
      <div class="cx_editor_footer right" v-if="isActionState2 || isActionState3 || editVisible || closeVisible || (owner && owner.dialogMode)">
        <!-- キーを指定しないとリサイクルされてショートカットキーが登録されない -->
        <!-- ダイアログモードでの表示はspEditVisible/spCloseVisibleと一致する -->
        <Button class="button" @click="submit" :caption="executeMessage" :icon="executeIcon" sc="F9" :disabled="actionDisabled  || isSubmitting" v-if="isActionState2 || editVisible || (owner && owner.dialogMode && spEditVisible)" :perm="perm"  key="F9"/>
        <Button class="button" @click="cancel"  :caption="cancelMessage" :icon="cancelIcon" sc="F12" v-if="isActionState3 || closeVisible || (owner && owner.dialogMode && spCloseVisible)"   key="F12"/>
      </div>
      <!-- 非活性マスク=>不要 -->
      <!-- <div class="cx_editor_inactive_layer" v-if="owner && owner.$refs.listBox && owner.$refs.listBox.multiSelection"></div> -->
    </div>
  </div>
  <!-- popupモード用のフッタ -->  
  <div class="cx_editor_footer_wrapper cx_editor_footer_popup"  v-if="item != null && (owner && owner.popup)">
      <div class="cx_editor_footer_workflow"  v-if="($scopedSlots.menu || tooltip) && item != null &&isActionState==false && editVisible==false && closeVisible==false">
        <slot name="menu_right" :item="item" :editor="_self"></slot>              
        <Workflow :item="item" :index="owner.currentId" :isToolbar="true"  @updated="owner.$parent.onWorkflow" v-if="owner && owner.$parent && owner.$parent.onWorkflow" :perm="owner.perm + '.approve'"/>             
      </div>         

      <div class="cx_editor_footer right" v-if="owner && owner.popup">
        <!-- キーを指定しないとリサイクルされてショートカットキーが登録されない -->
        <Button class="button" @click="submit" :caption="executeMessage" :icon="executeIcon" sc="F9" :disabled="actionDisabled"  :perm="perm"  key="F9"/>
        <Button class="button" @click="cancel"  :caption="cancelMessage" :icon="cancelIcon" sc="F12"   key="F12"/>
      </div> 
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import * as Common from '@/agiles/common';
import * as Components from '@/agiles/components';


// タブ表示が可能な汎用エディタ機能を提供します。実行アクションなどはバインドします。必要に応じてクローン済みのオブジェクトをセットしてください。
@Component
export default class Editor extends Vue implements Components.IEditor {
  @Prop() public item: Common.ObjectBase;
  @Prop() public tabs?: string[];
  @Prop({ default: () => new Array() }) public tabVisibles?: boolean[];
  @Prop({ default: () => new Array() }) public tabTooltips?: boolean[];  
  @Prop({ default: null }) public perm: string;
  @Prop({ default: false }) public editVisible: boolean;
  @Prop({ default: true }) public spEditVisible: boolean;  
  @Prop({ default: false }) public closeVisible: boolean;
  @Prop({ default: true }) public spCloseVisible: boolean;    
  @Prop({ default: '更新する' }) public execCaption: string;
  @Prop({ default: null }) public owner: Components.ListView;
  // @Prop({ default: true }) public autoScroll: boolean;
  @Prop({ default: false }) public isFullSizeEditor: boolean;
  @Prop({ default: true }) public tooltipVisible: boolean;  

  public get isAdminSite() :boolean{
    return Common.Api.siteMode == Common.siteModes.admin;
  }
  public get columnStyle() : boolean {
    return this.owner && this.tabs.length > 1 && ((this.owner.dialogMode && this.$api.innerHeight >= 800) ||  (this.owner.dialogMode == false && this.owner.columnStyle  && this.$api.innerHeight >= 720) );
  }

  public adjust(list : any[]){
    //タブ側で初期化される場合があるので、クローンしたものを渡す必要がある
    if (list) return this.columnStyle && list.length > 0 ? list.slice(1) : list.slice(0);
    else return [];
  }
  public isMinimized:boolean = false;
  public onResize(){
    this.$nextTick(()=>{
      if(this.$el.clientHeight < 100 && this.$api.spMode == false) this.isMinimized = true;
      else this.isMinimized = false;
    });
  }
  public tooltip?: string;
  public tooltipIsAlert:boolean = false;
  public tabInvalids:boolean[] = [] ;
  public editorState: Common.editorStates = Common.editorStates.Read;
  public actionDisabled: boolean = false;
  public get isActionState(): boolean {
    return this.editorState != Common.editorStates.Read;
  }
  public get isActionState2(): boolean {
    return this.editorState != Common.editorStates.Read || (this.$api.spMode && this.spEditVisible);
  }
  public get isActionState3(): boolean {
    return this.editorState != Common.editorStates.Read || (this.$api.spMode && this.spCloseVisible);
  }
  public actionTooltipVisible : boolean = true;

  //ボタンキャプション
  public executeMessage: string = '編集する';
  public executeIcon: string = null;
  public cancelMessage: string = '';
  public cancelIcon: string = null;

  //イベントターゲット
  private source: HTMLElement;
  private target: HTMLElement;

  //#region コントロールバリデーション

  public validator: Components.Validator = new Components.Validator();
  public controls: Components.IControl[] = new Array();

  public addControl(control: Components.IControl) {
    if (control.validator != null) {
      this.validator.Validators.push(control.validator);
    }
    control.isEdit = this.isEdit;
    this.controls.push(control);
  }
  public removeControl(control: Components.IControl){
    if (control.validator != null) {
      var index = this.validator.Validators.indexOf(control.validator);
      if (index != -1) this.validator.Validators.splice(index, 1);
    }    
    var index1 = this.controls.indexOf(control);
    if (index1 != -1) this.controls.splice(index1, 1);    
  }
  //#endregion


  // public get statusList():string{
  //   if (this.owner && this.owner.$refs && this.owner.$refs.listBox)
  //   {
  //      var gridItem = (this.owner.$refs.listBox as Vue).$children.find(obj=>obj.$children != null && obj.$children.length > 0 && obj.$children[0].$el.className == '');   
  //      if(gridItem) return (gridItem.$children[0] as Components.Badge).list;
  //   }
  //   return null;
  // }
  //#region　フォーカス制御～Read以外の場合に確認ダイアログを表示する

  public created() {
    document.body.addEventListener('click', this.onClickOtherElement, { capture: true });
    document.body.addEventListener('focusin', this.onClickOtherElement, { capture: true });
    if(this.item){
       this.tooltip = this.item.actionTooltip;
       this.tooltipIsAlert = this.item.actionIsAlert;;
    }
    if (this.adjust(this.tabs)) this.tabs.forEach(text => this.tabInvalids.push(false));    //editorで更新するのでcolumnStyleを考慮したタブ数に合わせる

    if (this.owner != null) {
      //リストビューにsetStateへのアクセスを提供する
      if (this.isFullSizeEditor) this.owner.editor = this;
      else this.owner.sideEditor = this;

      //ダイアログ表示する際の高さを調整
      this.owner.editorHalfHeight = this.tabs && this.tabs.length == 1;

      //イベントをバインドする
      this.$on('cancel', this.owner.onCancel);
      this.$on('close', this.owner.onClose);//閲覧モードでdialog表示するため、ターゲットメソッドを分離
      this.$on('execute', this.owner.onExec);
      this.owner.$on('resize',this.onResize);
    }

    this.actionTooltipVisible =  localStorage.actionTooltipVisible == null ||  localStorage.actionTooltipVisible == 'true';
  }

  public mounted() {
    this.setState(Common.editorStates.Read);
    //権限チェックを行う
    this.actionDisabled = this.$api.perms.hasMenuPermission(this.perm) == false;
    this.onResize();//ロード直後に判定を実施
  }

   @Watch('actionTooltipVisible')
  public onSideFilterChanged() {
    localStorage.actionTooltipVisible = this.actionTooltipVisible;
  } 
  @Watch('item')
  public onItemChanged(){
    //行選択変更時とワークフローアクション実行後に呼び出されます。
    if (this.item){
      this.tooltip = this.item.actionTooltip;
      this.tooltipIsAlert = this.item.actionIsAlert;
      //アクションツールチップを停止したため以下コメント
      // if(this.tooltipComponent) this.tooltipComponent.$destroy();    
      // if(this.tooltip) this.$nextTick(()=>{
      //   this.tooltipComponent = this.$api.tooltip.mount(this, this.$refs.tooltip_target as Element,this.tooltip);
      // });    
      this.updateTabState();
    }
  }
  public tooltipComponent: Components.Tooltip;

  public destroyed() {
    document.body.removeEventListener('click', this.onClickOtherElement, { capture: true });
    document.body.removeEventListener('focusin', this.onClickOtherElement, { capture: true });
  }

  public onClickOtherElement(e: any) {
    if (this.editorState != Common.editorStates.Read) {
      console.log('outside click on editor');
      const modal = document.getElementById('builtinModal');
      const modal2 = document.getElementById('popupEditor');
      const modal3 = document.getElementById('workflowDialog');      
      const modal4 = document.getElementById('dialogEditor');  //ヘッダ部などで警告メッセージが表示されるのを回避                
      const tooltips = document.getElementsByClassName('tooltip'); // ツールチップクリック時の表示を回避
      // リンクとカードはクリックをハックする(フォーカスだとtargetがDIVだったりするため)
      // 入力コントロールはフォーカスをハックする
      if (this.$el.contains(e.srcElement)) {
        return;
      } else if (e.type == 'focusin' && e.srcElement.tagName.toLowerCase() != 'input' && e.srcElement.tagName.toLowerCase() != 'select') {
        return;
      } else if (modal != null && modal.contains(e.srcElement)) {
        return;
      } else if (modal2 != null && modal2.contains(e.srcElement)) {
        return;        
      } else if (modal3 != null && modal3.contains(e.srcElement)) {
        return;               
      } else if (modal4 != null && modal4.contains(e.srcElement)) {
        return;                        
      } else if (tooltips.length != 0 && tooltips[0].contains(e.srcElement)) {
        return;
      } else if ((e.srcElement as HTMLElement).className.includes('edit_focus') || (e.srcElement as HTMLElement).parentElement.className.includes('edit_focus')) {
        //ソースエレメントとその親にedit_focusクラスが付与されているかどうかを調べる。あまりネストするとパフォーマンスが悪くなるので。
        return;
      // } else if (e.srcElement.lastChild.id == 'spinner'){
      //   //オートコンプリートのスピナー
      //   return ;
      }else if (e.srcElement.closest(".modal-dialog")){ 
        //モーダルに含まれている場合は編集処理の一部として扱う
        return;
      }

      // //サイドバーの表示制御ボタンのクリックを許可=>左右配置で閉じる際は破棄したいのでコメント
      // if((e.srcElement as HTMLElement).id == 'sidebar_left' || (e.srcElement as HTMLElement).id == 'sidebar_right' )
      // {
      //   e.relatedTarget.focus();
      //   return;
      // }

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      this.source = e.relatedTarget; // フォーカス移動元
      this.target = e.srcElement; // フォーカス移動先
      this.$api.modal.show('確認メッセージ', '編集中のデータは保存されていません。破棄してもよろしいですか?', false, this.onExit,null,'破棄する','戻る');
      return false;
    }
  }
  /** 編集状態を解除してイベント処理を継続します。 */
  public onExit() {
    if (this.target != null) {
      this.setState(Common.editorStates.Read);
      this.$emit('cancel');
      this.$nextTick(() => {
        if (this.target.tagName.toLowerCase() == 'input' || this.target.tagName.toLowerCase() == 'select') {
          this.target.focus();
        } else {
          this.target.click();
        }
      });
    } else {
      this.source.focus();
    }
  }

  // #endregion

  // #region エディット状態の制御
  public isSubmitting=false;

  public submit() {
    //ダブルクリック防止
    if (this.isSubmitting) return;    
    this.isSubmitting = true;
    this.$nextTick(()=>this.isSubmitting = false);

    if (this.editorState === Common.editorStates.Read) {
      if (this.owner)this.owner.onEdit(); //バリデーションの実装
      else {
        this.setState(Common.editorStates.Edit);
        this.$emit('edit');
      }
    } else if (this.editorState === Common.editorStates.Edit) {
      if (this.validator.validate()) {
        //確認画面の廃止
        // this.setState(Common.editorStates.Confirm);
        this.$emit('execute', this.item);
      }
    } else if (this.editorState === Common.editorStates.Confirm) {
      //正常完了時のみエディタの状態を更新する=>制御はイベントハンドラに任せる。
      this.$emit('execute', this.item);

      // if (this.owner != null){
      //   this.owner.onExec(this.item).then(() => this.setState(Common.editorStates.Read));
      // } else {
      //   this.action(this.item).then(() => this.setState(Common.editorStates.Read));
      // }
    }
    this.updateTabState();    
  }
  public updateTabState(){
    if (this.$refs.tab){
      var invalidControls = this.controls.filter(ctrl =>ctrl.validator ? ctrl.validator.validateMessage : false);
      var tabs = (this.$refs.tab as Components.Tab).tabElements;
      tabs.forEach((el,index) =>{
          var tabOwned = invalidControls.filter(ctrl =>el.contains((ctrl as any as Vue).$el));
          this.$set(this.tabInvalids,index,tabOwned.length > 0);
      });
    }
  }
  public cancel() {
    if (this.editorState === Common.editorStates.Edit) {
      var isInsertMode = this.owner ? this.owner.isInsertMode : false;
      this.setState(Common.editorStates.Read);
      this.$emit('cancel');
      if (isInsertMode && this.owner && this.owner.popup){
        this.owner.popup.onClose();
      } else if (isInsertMode && this.$api.spMode && this.owner != null) {
        (this.owner as Components.ListView).setVisibleState('list');
      }
    } else if (this.editorState === Common.editorStates.Confirm) {
      this.setState(Common.editorStates.Edit);
    } else if (this.editorState === Common.editorStates.Read) {
      if (this.owner && this.owner.popup){
        this.owner.popup.onClose();
      } else if (this.$api.spMode && this.owner != null) {
        (this.owner as Components.ListView).setVisibleState('list');
      }
      this.$emit('close');
    }
    this.$nextTick(()=>this.updateTabState());        
  }
  public get isEdit(): boolean {
    return this.editorState != Common.editorStates.Read;
  }

  public isLoading:boolean = false;
  public setState(state: Common.editorStates) {
    this.editorState = state;
      var isInsertMode = this.owner ? this.owner.isInsertMode : false;
    // ボタンキャプション更新・コントロール編集状態制御
    if (state === Common.editorStates.Edit) {
      this.setControls(true);
      //新規追加or複製の場合は最初のタブを選択、編集時は現在のタブ（非ダイアログモード時）
      if (this.$refs.tab && isInsertMode) (this.$refs.tab as Components.Tab).onClick(0);
      if (this.controls.filter(obj =>obj.enabled).length == 0) {
        this.$api.modal.show("無効な操作",this.item.messageOnEdit,true,null);
        this.setControls(false);
        this.editorState = Common.editorStates.Read;
        if(this.owner) this.owner.onCancel();
        return;
      }
      //確認するの廃止
      // this.executeMessage = '確認する';
      // this.executeIcon = 'check';
      this.isLoading = true;
      window.setTimeout(()=>{
        this.executeMessage = this.execCaption;
        if (isInsertMode) this.executeMessage = '追加する';
        else this.executeIcon = 'update';      
        this.cancelMessage = 'キャンセル';
        this.cancelIcon = 'cancel';
        this.setControls(true);
        this.$api.sckeys.filter = (key:string) =>key == "F9" || key == "F12";
        this.$nextTick(() => this.focus());
        this.isLoading = false;
      },300);

    } else if (state === Common.editorStates.Confirm) {
      this.executeMessage = this.execCaption;
      this.executeIcon = 'update';
      this.cancelMessage = '戻る';
      this.cancelIcon = 'undo';
      this.setControls(false);
      this.$api.sckeys.filter = (key:string) =>key == "F9" || key == "F12";
    } else if (state === Common.editorStates.Read) {
      this.executeMessage = '編集する';
      this.executeIcon = 'edit';
      this.cancelMessage = '閉じる';
      this.cancelIcon = '';
      this.setControls(false);
      this.$api.sckeys.filter = null;
    }

    this.$forceUpdate();
  }

  setControls(isEdit: boolean) {
    this.controls.forEach(obj => (obj.isEdit = isEdit));
  }

  /**エディタの最初のコントロールにフォーカスをセットします */
  public focus() {
    // this.controls[0].focus();
    var focussableElements = 'a:not([disabled]), button:not([disabled]),select:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
    if (this.$refs.tab0 != null) {
      const target = (this.$refs.tab0 as HTMLElement[])[0];
      var focussable = target.querySelectorAll(focussableElements);
      if (focussable != null && focussable.length > 0) {
        const input = focussable[0] as HTMLElement;
        input.focus();
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/agiles/components/style.scss';

.cx_editor {
  @extend .cx_vertical_fill;
  overflow-x: hidden;
  min-width: 300px;

  &.loading{
    opacity: 0.5;
  }
    .cx_grid{
      margin-bottom :15px;
    }

  .cx_editor_content {
    @extend .cx_vertical_fill;
    // background-color: white;
    padding-top: 2px;
    .cx_editor_content_header {
      //タブ表示との兼ね合いで高さ調整
      margin-top :15px;
      .cx_edtior_caption{
        width:100%;
        padding-left:30px;
        display:flex;
        margin-bottom:10px;
      }
      .cx_editPanel {
        padding-bottom: 5px;
        height: 340px;        
      }
    }
    .cx_editor_body {
      display: flex;
      height: 100%;      

      .cx_spmode & {
        //在庫一覧で横が見切れる場合があった
        .cx_editPanel {
          overflow-x:auto;

          .cx_editPanel_left,
          .cx_editPanel_right {
            min-width: fit-content;            
          }
        }
      }

    }
    .tab-content {
      overflow-y: hidden;
      .card-body {
        padding: 20px 0px !important;
      }
    }

    .card-header {
      padding-top: 0px;
      background-color: inherit;
    }
  }
  .cx_editor_menu {
      margin-left:30px;
      margin-bottom: 10px;
      display: flex;
      justify-content:flex-start;

      button {
        margin-right: 20px;
      }
  }
  .cx_editor_footer_border{
    background-color: #F7F7F7;    
    position:relative;
    .cx_editor_footer_border_innter{
      margin: 0px 30px;
      border-bottom: thin solid  #e7e7e7;    
      font-size:12px;
      color: #9e9e9e;
      height: 23px;
      .tooltip_alert {
        color:#f3342d;
      }
      .cx_tooltip_message{
        margin: 0px 120px;
        white-space: nowrap;
        line-height: 22px;
      }
      .vue-js-switch{
        position:absolute;
        left :35px;
      }  

    }
  }
  //splitButtonを表示するためにrelative属性を配置するためのdiv
  .cx_editor_footer_container{
      position: relative;
      display: flex;
      width: 100%;      
  }
  .cx_editor_footer_wrapper{
    display: flex;
    width: 100%;
    background-color: #F7F7F7;

    .cx_spmode & {
      //splitButtonが表示されないためコメント=>復活
      overflow-x:auto;
    }
    //.cx_editor_footer_containerに移動
    // position: relative;
    //非活性化レイヤー
    .cx_editor_inactive_layer{
      position: absolute;
      height: 100%;
      width: 100%;
      background: #f7f7f7;
      opacity: 1;
    }
  }
    .cx_editor_tooltip {
       min-width: 150px;
       padding-top:17px;
      // display: flex;
      // flex-direction: column;
      // justify-content: center;
        span{
          margin-top : 7px;
          margin-left : 20px;
          // margin-right: 40px;
          font-size: 16px;
          // font-weight: 700;
          color: #e62c1f;          
          // color: #ca2323;
        }


      i.small {
        margin-left:2px;
        margin-top:-3px;
        margin-right:0px;
        font-size: 22px;
        //color:#9e9d9d;      

        &:hover{
          color:#be1003;                
          cursor:pointer;
        }      

      }     
    }  
  .cx_editor_footer {
    /* 下部に固定 */
    height: 55px;
    // border-top: thin solid lightgray;
    padding: 10px 20px;
    flex: 1;
    // margin: 0px 20px;
    white-space: nowrap;
    display:flex;
    &.left {
      justify-content:flex-start;
      padding-right: 10px;
      flex:0;
    }

    &.cx_footer_nopadding{
      padding-left :30px;
    }
    &.right {
      justify-content:flex-end;
    }

    button {
      /* ボタン間隔を調整 */
      margin: 0 5px;
      font-size: 14px;
      height: 35px;
      // color:#2C304F !important;
    }


  }
  .cx_editor_footer_popup {
      .cx_editor_footer_workflow{
        justify-content: flex-start;
        margin-left : 70px;
      }
  }
  .cx_editor_footer_workflow{
    /* 下部に固定 */
    height: 55px;
    // border-top: thin solid lightgray;
    padding: 10px 20px 10px 20px;
    flex: 1;
    // margin: 0px 20px;
    white-space: nowrap;
    // margin-left:auto;
    display:flex;    
      justify-content:flex-end;    



    >button {
      font-size: 14px;        
      padding: 4px 15px 4px 15px;
      margin : 3px 5px 1px 5px;
      border-radius: 5px;        
      min-width: 110px;
      background : unset  !important;
      text-shadow: none;
      color:white  !important;
      background-color : #d1782f !important;
      border-color: #b4602f  !important;
      &:hover:not(:disabled){
        background-color : #e7a077 !important;
      }
      &:disabled{
        background-color : lightgray !important;
        border-color: lightgray !important;
      }           
    }
  }
}
</style>
